import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  display: flex;\n  flex-shrink: 0;\n  font-size: ", ";\n  font-weight: ", ";\n  height: ", ";\n  justify-content: center;\n  max-width: 100%;\n  overflow: hidden;\n  text-transform: uppercase;\n  user-select: none;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { FetchingStatus } from '@scp/ui-shared/core';
import { CircleLoader } from '@scp/ui-shared/components/loaders/content-loaders';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color as colorVar, typography } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToRem, rem, getCSSUnitValue, toNumericPxValue } from '@scp/ui-shared/theme/utils';
var E2E_ITEM_SUFFIX = '-avatar';
export var DEFAULT_AVATAR_SIZE = baselineToRem(8);
export var DEFAULT_AVATAR_FONT_SIZE = rem(typography.defaultFontSize);
var PROPS_TO_OMIT = ['color', 'size', 'fontSize', 'backgroundColor'];
var StyledAvatar = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
}, function (props) {
  return getCSSUnitValue(props.fontSize);
}, typography.fontWeightSemiBold, function (props) {
  return getCSSUnitValue(props.size);
}, function (props) {
  return getCSSUnitValue(props.size);
});
var ImageAvatar = StyledAvatar.withComponent('img');
/**
 * @example ./docs/Avatar.md
 */

export function Avatar(_ref) {
  var title = _ref.title,
      iconName = _ref.iconName,
      status = _ref.status,
      _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === void 0 ? '' : _ref$imageUrl,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 18 : _ref$iconSize,
      _ref$initials = _ref.initials,
      initials = _ref$initials === void 0 ? '' : _ref$initials,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorVar.palette.white : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DEFAULT_AVATAR_SIZE : _ref$size,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorVar.avatarBackground : _ref$backgroundColor,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? DEFAULT_AVATAR_FONT_SIZE : _ref$fontSize,
      dataE2e = _ref.dataE2e;

  if (status === FetchingStatus.Loading) {
    return React.createElement(CircleLoader, {
      size: toNumericPxValue(size),
      status: status
    });
  }

  if (imageUrl) {
    return React.createElement(ImageAvatar, {
      src: imageUrl,
      alt: title,
      color: color,
      size: size,
      backgroundColor: backgroundColor,
      fontSize: fontSize,
      "data-e2e": getE2eLabel('image', E2E_ITEM_SUFFIX, dataE2e)
    });
  }

  return React.createElement(StyledAvatar, {
    "aria-hidden": true,
    color: color,
    title: title,
    size: size,
    backgroundColor: backgroundColor,
    fontSize: fontSize,
    "data-e2e": getE2eLabel('text', E2E_ITEM_SUFFIX, dataE2e)
  }, iconName ? React.createElement(Icon, {
    name: iconName,
    color: color,
    size: iconSize
  }) : initials);
}